import React from "react";

export const CourseStoreDetailInfoItem = ({image, title }) => {
    return (
        <div class='flex gap-[25px] items-center'>
        <div>
            {image}
        </div>

            <div class='text-nowrap'>
                {title || 'не указано'}
            </div>
        </div>
    );
};